import { render } from "./NewEmployee.vue?vue&type=template&id=02d52f54&scoped=true"
import script from "./NewEmployee.vue?vue&type=script&lang=js"
export * from "./NewEmployee.vue?vue&type=script&lang=js"

import "./NewEmployee.vue?vue&type=style&index=0&id=02d52f54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d52f54"]])

export default __exports__